export default __webpack_public_path__ + "static/side-menu-bg-00-5eec50b2b536b364cfe50545af6659cb.png";